export default __webpack_public_path__ + "static/banner-image-3ac792cfbe73cc3c8ad024616ad1bb6d.jpg";